import { Store } from '.';
import { MAX_MOBILE_WIDTH, MAX_TABLET_WIDTH } from '../../constants';

export type DeviceSlice = {
  isMobile: boolean;
  isTablet: boolean;
  setDeviceFromWidth: (width: number) => void;
};

export const getDeviceInitialState = (
  set: (stateUpdater: (state: Store) => Partial<Store>) => void
): DeviceSlice => ({
  isMobile: false,
  isTablet: false,
  setDeviceFromWidth: (width: number) => {
    set((state) => ({
      deviceSlice: {
        ...state.deviceSlice,
        isMobile: width <= MAX_MOBILE_WIDTH,
        isTablet: width > MAX_MOBILE_WIDTH && width < MAX_TABLET_WIDTH,
      },
    }));
  },
});
